import React from "react";
import AuthUser from "./AuthUser"
import useUserAuthentication from "./useUserAuthentication"
const Authenticated = ({ children }) => {
  const { isPending, state } = useUserAuthentication();
  if (isPending) {
    return <AuthUser />;
  } else {
    if (state.isAuthticated) {
      return children;
    }
  }
};

export default Authenticated;
